import { render, staticRenderFns } from "./TopScore.vue?vue&type=template&id=46c112b1&scoped=true&"
import script from "./TopScore.vue?vue&type=script&lang=js&"
export * from "./TopScore.vue?vue&type=script&lang=js&"
import style0 from "./TopScore.vue?vue&type=style&index=0&id=46c112b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c112b1",
  null
  
)

export default component.exports